module.exports = __webpack_public_path__ + "img/modal_close.0281d9c0.svg";